import type {z} from "zod";
import {AddCustomerOfferNoteBody} from "@project/sdk/sales/zod";
import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const addCustomerOfferNoteTitleSchema = requiredStringSchema(
  AddCustomerOfferNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const addCustomerOfferNoteContentSchema = requiredStringSchema(
  AddCustomerOfferNoteBody.shape.content,
  noteFieldLabelIds.content,
);
export const addCustomerOfferNoteFormSchema = AddCustomerOfferNoteBody.strict().extend({
  title: addCustomerOfferNoteTitleSchema,
  content: addCustomerOfferNoteContentSchema,
});
export type AddCustomerOfferNoteFormPayload = z.output<typeof addCustomerOfferNoteFormSchema>;
export const draftAddCustomerOfferNoteFormSchema = addCustomerOfferNoteFormSchema.partial();
export type DraftAddCustomerOfferNoteFormPayload = z.output<
  typeof draftAddCustomerOfferNoteFormSchema
>;
